export const useToggle = ({ onChange, disabled }) => {
  const handleChange = (e) => {
    if (disabled) return;
    if (onChange) {
      onChange(e);
    }
  };

  return {
    handleChange,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Toggle/hooks/useToggle.js